import { SidebarType } from '@/types/sidebar';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type SidebarState = {
  dataSidebar: SidebarType[];
  activeContextType: string | null;
  sidebarError: boolean;
};

export const sidebarInitialState: SidebarState = {
  dataSidebar: [],
  activeContextType: null,
  sidebarError: false,
};

export const slice = createSlice({
  name: 'sidebar',
  initialState: sidebarInitialState,
  reducers: {
    resetSidebarAction() {
      return sidebarInitialState;
    },
    setListSidebarAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: SidebarType[];
      }>,
    ) {
      state.dataSidebar = payload.data;
      state.activeContextType = payload.data[0]?.menus?.[0]?.activeContextType || null;
      state.sidebarError = false;
    },
    setSidebarErrorAction(state) {
      state.sidebarError = true;
      state.dataSidebar = [];
    },
  },
});

export const { resetSidebarAction, setListSidebarAction, setSidebarErrorAction } = slice.actions;

export default slice.reducer;
